import { Col, Row } from "react-bootstrap";
import { WfsParametersV2 } from "../../../types/Wfs/WfsParametersV2";
import { useMemo } from "react";

export interface OSHighwaysFiltersProps {
  wfsParameters: WfsParametersV2;
}

const OSHighwaysFilters = ({ wfsParameters }: OSHighwaysFiltersProps) => {
  return (
    <>
      <Row>
        <Col md="3">Feature Type</Col>
        <Col md="9">
        {wfsParameters.featureType?.toString()
                      .replace(/([a-z])([A-Z])/g, "$1 $2")}</Col>
      </Row>
      {wfsParameters.users && (
        <Row>
          <Col md="3">Users or terminals to license for</Col>
          <Col md="9">{wfsParameters.users}</Col>
        </Row>
      )}
    </>
  );
};

export default OSHighwaysFilters;
